<template>
  <CHeader with-subheader>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand
      class="mx-lg-auto d-lg-none"
      src="/img/brand/logo_skl.svg"
      width="97"
      height="46"
      alt="CoreUI Logo"
    />
    <div>
      <h1 class="text-uppercase ml-2 theheader-txt font-weight-bold">
        Brand Center
      </h1>
    </div>
    <CHeaderNav class="d-md-down-none mr-auto">
      <!-- <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard">
          Dashboard
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/users" exact>
          Users
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink>
          Settings
        </CHeaderNavLink>
      </CHeaderNavItem>-->
    </CHeaderNav>
    <CHeaderNav class="mr-1 mr-sm-4">
      <!-- <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <ul>
            <li v-for="lang in languages" :key="lang" @click="changeLang(lang)">{{lang}}</li>
          </ul>
        </CHeaderNavLink>
      </CHeaderNavItem>-->
      <!-- <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-bell" class="text-warning" />
        </CHeaderNavLink>
      </CHeaderNavItem>-->
      <CHeaderNavItem class="d-md-down-none mx-2">
        <div>
          <span v-if="profileInfo.seller.statusId == 2">
            <font-awesome-icon
              icon="check-circle"
              title="View"
              class="mr-2 text-success"
            />Verified Account</span
          >
          <span v-else>
            <font-awesome-icon
              icon="check-circle"
              title="View"
              class="mr-2 text-secondary"
            />Unverified Account
          </span>
        </div>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none">
        <b-dropdown class="my-2 lang-dd" right no-caret>
          <template v-slot:button-content>
            <div class="form-inline">
              <div v-if="language == 'en'">
                <img
                  src="@/assets/images/united-states.png"
                  class="partner-logo"
                />
              </div>
              <div v-else-if="language == 'th'">
                <img src="@/assets/images/thailand.png" class="partner-logo" />
              </div>
              <!-- <font-awesome-icon icon="chevron-down" class="align-middle mt-1 ml-1 text-dark" size="sm" /> -->
            </div>
          </template>
          <b-dropdown-item @click="changeLanguage('en')">EN</b-dropdown-item>
          <b-dropdown-item @click="changeLanguage('th')">TH</b-dropdown-item>
        </b-dropdown>
      </CHeaderNavItem>
      <!-- <TheHeaderDropdownAccnt /> -->
      <!-- <CHeaderNavItem class="mr-2">
        <a href="#" @click.prevent="logout">
          <CIcon name="cil-lock-locked" />
          <span class="ml-1">Logout</span>
        </a>
      </CHeaderNavItem>-->
    </CHeaderNav>
    <CSubheader class="px-3">
      <!-- <CBreadcrumbRouter class="border-0" /> -->
      <CBreadcrumb :items="breadcrumbs" class="border-0" />
    </CSubheader>
    <ModalAlertWarningNoti ref="modalAlertWarningNoti" :item="bannerClose" />
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import ModalAlertWarningNoti from "./../components/modal/alert/ModalAlertWarningNoti";
import { mapState } from "vuex";

export default {
  name: "TheHeader",
  data() {
    return {
      displayName: "",
      language: this.$language,
      breadcrumbs: [],
      bannerClose: null,
      routeMeta: {
        // isChildren: false,
      },
      // languages: ["en", "th"]
    };
  },
  components: {
    TheHeaderDropdownAccnt,
    ModalAlertWarningNoti,
  },
  created: async function () {
    //await this.getProfile();
    this.getBannerClose();
    setTimeout(async () => {
      this.handleActiveMenuChild(this.$route.meta);
    }, 650);
  },
  mounted: async function () {
    this.handleBreadcrumbs(this.$route.matched);
  },
  computed: {
    ...mapState({
      profileInfo: (state) => state.profile,
    }),
  },
  watch: {
    "$route.meta"(newValue, oldValue) {
      this.handleActiveMenu(newValue, oldValue);
    },
    "$route.matched"(newValue, oldValue) {
      this.handleBreadcrumbs(newValue);
    },
  },
  methods: {
    //   changeLang(lang) {
    //     this.$i18n.locale = lang;
    //   },
    handleBreadcrumbs(list) {
      this.breadcrumbs = [];
      list.forEach((item, i) => {
        if (item.name)
          this.breadcrumbs.push({
            text: this.$t(item.name),
            href: !this.$store.state.profile.isAdmin ? item.redirect : "",
          });
      });
    },
    handleActiveMenu: async function (newValue, oldValue) {
      if (newValue.activeUrl != oldValue.activeUrl) {
        await this.handleRemoveActiveMenuChild(oldValue);
      }
      await this.handleActiveMenuChild(newValue);
    },
    handleActiveMenuChild: async function (meta) {
      this.routeMeta = meta;
      var ele = await this.getAllElementsWithAttribute(
        "a",
        "href",
        meta.activeUrl
      );
      if (meta.isChildren && ele.className == "c-sidebar-nav-link")
        await ele.setAttribute(
          "class",
          "router-link-exact-active c-active c-sidebar-nav-link"
        );

      var parentElement = ele;
      if (meta.lv == 1 && ele.className == "c-sidebar-nav-dropdown")
        ele.setAttribute("class", "c-sidebar-nav-dropdown c-show");
      else if (meta.lv == 2) {
        parentElement = parentElement.parentElement.parentElement.parentElement;
        if (
          parentElement &&
          parentElement.className == "c-sidebar-nav-dropdown"
        )
          parentElement.setAttribute("class", "c-sidebar-nav-dropdown c-show");
      }

      if (
        meta.lv == 3 &&
        parentElement.parentElement.parentElement.className ==
          "c-sidebar-nav-dropdown"
      )
        parentElement.parentElement.parentElement.setAttribute(
          "class",
          "c-sidebar-nav-dropdown c-show"
        );

      // setTimeout(()=>{
      //   var div = document.getElementsByClassName("ps__rail-y")[0];
      //   div.style.top = `${this.getAllElementsWithAttribute('a', 'href', meta.activeUrl).getBoundingClientRect().top}px`
      //   ele.focus();
      // }, 500);
    },
    handleRemoveActiveMenuChild: async function (oldMeta) {
      var oldEle = this.getAllElementsWithAttribute(
        "a",
        "href",
        oldMeta.activeUrl
      );
      if (!oldEle) return;

      oldEle = await this.getAllElementsWithAttribute(
        "a",
        "href",
        oldMeta.activeUrl
      );
      if (
        oldMeta.isChildren &&
        oldEle.className ==
          "router-link-exact-active c-active c-sidebar-nav-link"
      )
        await oldEle.setAttribute("class", "c-sidebar-nav-link");

      var parentElement = oldEle;
      if (
        oldMeta.lv == 1 &&
        oldEle.className == "c-sidebar-nav-dropdown c-show"
      )
        oldEle.setAttribute("class", "c-sidebar-nav-dropdown");
      else if (oldMeta.lv == 2) {
        parentElement = parentElement.parentElement.parentElement.parentElement;
        if (
          parentElement &&
          parentElement.className == "c-sidebar-nav-dropdown c-show"
        )
          parentElement.setAttribute("class", "c-sidebar-nav-dropdown");
      }

      if (
        oldMeta.lv == 3 &&
        parentElement.parentElement.parentElement.className ==
          "c-sidebar-nav-dropdown c-show"
      )
        parentElement.parentElement.parentElement.setAttribute(
          "class",
          "c-sidebar-nav-dropdown"
        );
    },
    getAllElementsWithAttribute(tagName, attribute, val) {
      var allElements = Array.from(document.getElementsByTagName(tagName));
      var filtered = allElements.filter((ele) => {
        return (
          ele.getAttribute(attribute) !== null &&
          ele.getAttribute(attribute) == val
        );
      });
      if (filtered.length) return filtered[0];
      else return false;
    },
    changeLanguage: async function (value) {
      this.language = value;
      await this.$cookies.remove("language");

      await this.$cookies.set(
        "language",
        value,
        60 * 60 * 24 * 365,
        "/",
        this.$cookiesDomain
      );
      location.reload();
    },
    getProfile: async function () {
      let resData = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/info`,
        null,
        this.$headers,
        null
      );
      if (resData.result == 1) {
        this.displayName =
          resData.detail.admin.firstName + " " + resData.detail.admin.lastName;
      }
    },
    logout: async function () {
      let resData = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/logout`,
        null,
        this.$headers,
        null
      );
      this.$cookies.remove("adminSellerId");
      this.$cookies.remove("seller-token");
      window.location.href = "/";
    },
    getBannerClose: async function () {
      let resData = await this.$callApi(
        "get",
        `${this.$baseUrl}/api/BannerClose`,
        null,
        this.$headers,
        null
      );
      if (resData.result == 1) {
        this.bannerClose = resData.detail;
        this.$nextTick(() => {
          if (this.bannerClose.isShow) this.$refs.modalAlertWarningNoti.show();
        });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .lang-dd button {
  background-color: transparent;
  border: none;
  padding: 0;
}

::v-deep .lang-dd button:focus,
::v-deep .lang-dd button:active,
::v-deep .lang-dd.show > .btn-secondary.dropdown-toggle,
::v-deep .lang-dd button:hover {
  background-color: transparent !important;
  border: none;
  padding: 0;
}

.lang-dd {
  padding: 5px 10px;
}

::v-deep .lang-dd ul {
  width: 200px;
  padding: 5px;
}

.partner-logo {
  width: 25px;
}
</style>
